import React, { useContext, useEffect } from "react";
import {
  Button,
  Card,
  Carousel,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  message,
} from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";
import APIClient from "../../helpers/ApiClient";
import { TgContext } from "../../common/providers/TgProvider";
import CombinedBanner from "../CombinedBanner/CombinedBanner";
import { MailOutlined } from "@ant-design/icons";
import "../CombinedHome/CombinedHome.scss";
import CombinedOverallSearch from "../CombinedOverallSearch/CombinedOverallSearch";
import queryString from "query-string";
import Login from "../Login/LoginBan";
import Footer from "../../common/footer/Footer";

const { Panel } = Collapse;
const CombinedHome = (props) => {
  const [subsribeForm] = Form.useForm();
  let history = useHistory();
  const { updateTabKey } = useContext(TgContext);
  const oriDateString = "YYYY-MM-DD";
  const { updataCombineSearchObj, RemovePromo } = props.gscontext;
  const { combineSearchData } = props.gscontext.state;
  const subsribeData = {
    DeviceOS: 3,
    ApplicationType: 1,
    Email: "string",
    Status: 0,
    CreatedBy: 0,
    DeviceOSVersion: "string",
    DeviceToken: "string",
    FirBaseToken: "string",
  };
  // console.log("CombinedHome");
  const handleSubscibe = (value) => {
    let data = {
      ...subsribeData,
      ...value,
    };
    APIClient.post("admin/subscriberReport", data)
      .then((response) => {
        if (response.status == 200) {
          message.success("Subscibed SuccessFully", 3);
          subsribeForm.resetFields();
        } else if (response.status == 400) {
          message.error("This Email Address Has Already Subscribed.", 3);
        } else if (response.status == 404) {
          message.error("Failed", 3);
        } else {
          message.error("Something Went Wrong", 3);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const topCities = [
    {
      origin: {
        airports: {
          airportCodeIATA: "BLR",
        },
        busStops: {
          Id: 109,
        },

        name: "Bangalore",
      },
      destination: {
        airports: {
          airportCodeIATA: "BOM",
        },
        busStops: [],

        name: "Mumbai",
      },
    },

    {
      origin: {
        airports: {
          airportCodeIATA: "BLR",
        },
        busStops: {
          Id: 109,
        },

        name: "Bangalore",
      },
      destination: {
        airports: {
          airportCodeIATA: "PNQ",
        },
        busStops: {
          Id: 114,
        },

        name: "Pune",
      },
    },

    {
      origin: {
        airports: {
          airportCodeIATA: "BLR",
        },
        busStops: {
          Id: 109,
        },

        name: "Bangalore",
      },
      destination: {
        airports: {
          airportCodeIATA: "HYD",
        },
        busStops: {
          Id: 100,
        },

        name: "Hyderabad",
      },
    },

    {
      origin: {
        airports: {
          airportCodeIATA: "HYD",
        },
        busStops: {
          Id: 100,
        },

        name: "Hyderabad",
      },
      destination: {
        airports: {
          airportCodeIATA: "BOM",
        },
        busStops: [],

        name: "Mumbai",
      },
    },
  ];

  const searchTopCities = (data, tabKey) => {
    let tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
    updataCombineSearchObj("origin", data.origin);
    updataCombineSearchObj("destination", data.destination);
    updataCombineSearchObj("fromDate", tomorrow);
    updataCombineSearchObj("toDate", "");

    let query = {
      adult: 1,
      child: 0,
      class: "Economy",
      from: tomorrow,
      infant: 0,
      to: "",
      tripType: "oneWay",
      origin: `${data.origin.name}-${data.origin.airports.airportCodeIATA}-${data.origin.busStops.Id}`,
      destination: `${data.destination.name}-${data.destination.airports.airportCodeIATA}-${data.destination.busStops.Id}`,
    };
    updateTabKey(tabKey);

    let queryParams = queryString.stringify(query);
    history.push("/combinedresults?" + queryParams);
  };

  useEffect(() => {
    RemovePromo();
    updataCombineSearchObj("origin", []);
    updataCombineSearchObj("destination", []);
    updataCombineSearchObj("tripType", "oneWay");
    updataCombineSearchObj("classType", "Economy");

    if (combineSearchData)
      if (combineSearchData.fromDate) {
        if (
          moment(combineSearchData.fromDate, oriDateString) <
          moment().startOf("day")
        )
          updataCombineSearchObj("fromDate", moment().format(oriDateString));
      }
  }, []);

  return (
    <div className="combined-home">
      <div className="home-content">
        <div className="home-ban-im">
          <div className="image-container">
            <img
              className="homebann-im"
              src={require("../../assets/images/ban4.png")}
              alt="carousel-img"
            />
          </div>
          <div className="log-im">
            <Login gscontext={props.gscontext} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedHome;
